/**
 * Divider Widget Default Configuration
 *
 * Horizontal or vertical line divider for visual separation.
 */

export type DividerOrientation = 'horizontal' | 'vertical';
export type DividerStyle = 'solid' | 'dashed' | 'dotted';

export interface DividerWidgetConfig {
  displayName: string;
  orientation: DividerOrientation;
  style: DividerStyle;
  thickness: number;
  color: string;
  marginTop: number;
  marginBottom: number;
  width: string;
}

export const DIVIDER_DEFAULT_CONFIG: DividerWidgetConfig = {
  displayName: 'Divider',
  orientation: 'horizontal',
  style: 'solid',
  thickness: 1,
  color: '#DADBDD',
  marginTop: 16,
  marginBottom: 16,
  width: '100%',
};

/**
 * Create default configuration for a divider widget
 */
export const createDividerConfig = (): DividerWidgetConfig => ({
  ...DIVIDER_DEFAULT_CONFIG,
});

export default createDividerConfig;
